module.exports = __webpack_public_path__ + "img/a-014.prt.d2d392e1.jpg";